import React from "react";
import { navSections } from "../../data/navigation";
import { sectionComponents } from "../sections";

const Main = () => {
  const [heroSection, ...innerSections] = navSections;

  return (
    <>
      {React.createElement(sectionComponents[heroSection.id])}
      <div className="inner-container">
        {innerSections.map((section) =>
          React.createElement(sectionComponents[section.id], { key: section.id })
        )}
      </div>
    </>
  );
};

export default Main;
